<template>
  <div class="h-100">
    <div
      v-if="!itemData"
      class="text-center d-flex flex-column justify-content-center align-items-center h-100"
    >
      <span class="text-sm text-secondary">
        Manifest item info...
      </span>
    </div>
    <div
      v-else
      class="text-sm"
    >
      <b-row>
        <b-col>
          <div class="d-flex align-items-center text-md mb-1">
            <span class="text-thick">
              Properties
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex align-items-center info-row">
            <span
              class="text-secondary label-field"
            >
              URL:
            </span>
            <span>
              {{ itemData.uri }}
            </span>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="isSegment"
        class="info-row"
      >
        <b-col>
          <div class="d-flex align-items-center">
            <span
              class="text-secondary label-field"
            >
              Duration:
            </span>
            <span>
              {{ itemData.duration }}
            </span>
          </div>
        </b-col>
      </b-row>
      <template v-if="!isSegment">
        <b-row
          class="info-row"
        >
          <b-col>
            <div class="d-flex align-items-center">
              <span
                class="text-secondary label-field"
              >
                Bandwidth:
              </span>
              <span>
                {{ itemData.attributes.BANDWIDTH.toLocaleString() }}
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row
          class="info-row"
        >
          <b-col>
            <div class="d-flex align-items-center">
              <span
                class="text-secondary label-field"
              >
                Framerate:
              </span>
              <span>
                {{ itemData.attributes['FRAME-RATE'] }}
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row
          class="info-row"
        >
          <b-col>
            <div class="d-flex align-items-center">
              <span
                class="text-secondary label-field"
              >
                Resolution:
              </span>
              <span>
                {{ itemData.attributes.RESOLUTION.width }}x{{ itemData.attributes.RESOLUTION.height }}
              </span>
            </div>
          </b-col>
        </b-row>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParsedItemDisplay',
  props: {
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {

    }
  },
  computed: {
    isSegment() {
      if (!this.itemData) return false
      if (this.itemData.attributes) return false
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
  .info-row{
    margin-bottom:7px;
    .label-field{
      margin-right:7px;
    }
  }
</style>
